/**
 * 사무실 팔레트.
 *
 * 스프라이트 이미지를 쓰지 않고 전부 코드로 그린다. 저장소에 바이너리
 * 에셋이 없으면 색을 바꾸거나 타일을 추가하는 게 훨씬 가볍다.
 */
export const PALETTE = {
  floor: '#2b2f3a',
  floorSeam: '#252934',
  floorSpeck: '#333846',

  carpet: '#3a3350',
  carpetWeave: '#413a59',

  wall: '#181b23',
  wallTop: '#232733',

  deskTop: '#6b4f35',
  deskEdge: '#553f2a',
  monitor: '#12141a',
  monitorGlow: '#4a9aa5',
  keyboard: '#9aa0ab',

  plantPot: '#8a5a3c',
  plantLeaf: '#3f8a52',
  plantLeafDark: '#2f6b3e',

  doorFrame: '#7a5c3a',
  doorPanel: '#4a3a2a',

  cooler: '#5ab4d6',
  coolerBody: '#dfe4ea',
  coffeeBody: '#2a2d36',
  coffeeCup: '#e8dcc8',
  printerBody: '#7d838f',
  printerPaper: '#f2f2f2',
  boardFace: '#e9ecef',
  boardFrame: '#9aa0ab',
  boardInk: '#4a6fa5',

  shadow: 'rgba(0, 0, 0, 0.35)',
  nameText: '#e8eaed',
  nameBackdrop: 'rgba(0, 0, 0, 0.55)',

  bubbleFill: '#f3f4f6',
  bubbleText: '#15171c',
  whisperFill: '#ddd0ff',
  whisperText: '#241a3d',
  whisperRing: 'rgba(167, 139, 250, 0.16)',
  whisperRingEdge: 'rgba(167, 139, 250, 0.55)',
} as const;

/**
 * 결정적 의사난수.
 *
 * 바닥 얼룩 같은 장식이 매 프레임 깜빡이면 안 된다. 좌표에서 값을
 * 만들어 쓰면 항상 같은 자리에 같은 무늬가 나온다.
 */
export function tileNoise(x: number, y: number): number {
  const h = Math.imul(x * 374761393 + y * 668265263, 1274126177);
  return ((h ^ (h >>> 13)) >>> 0) / 0xffffffff;
}
